import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice';
import trendSlice from './slices/trendSlice';
import menuSlice from './slices/menuSlice';
import showpowerbiSlice from './slices/showpowerbiSlice';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import sideBarMenuSlice from './slices/sideBarMenuSlice';

const reducer = combineReducers({
  authSlice: authSlice,
  trendSlice: trendSlice,
  menuSlice: menuSlice,
  showpowerbiSlice: showpowerbiSlice,
  sideBarMenuSlice: sideBarMenuSlice
})

const persistConfig = {
  key: 'root',
  storage: storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)
export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => [thunk]
})

export const persistor = persistStore(store)


